import React, { useEffect } from 'react'
import FinesQuestionView from './components/FinesQuestionView'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const FinesQuestion = ({ i18n }) => {
  useEffect(() => {
    try {
      addToGoogleDataLayer('fines-question', 'Pay for a Road Test', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return <FinesQuestionView />
}

export default withTranslation('common')(FinesQuestion)
